import { List } from '@apollo/orbit';
import classnames from 'classnames';
import React from 'react';

import * as ApolloTypes from 'src/lib/graphqlTypes/types';
import {
  NormalizedSubgraphsMetricsField,
  fromGQLSubgraphsListItemToSubgraphsListItem,
} from 'src/lib/metrics';

import { SubgraphsListItem } from '../insightsListItem/SubgraphsListItem';

type SubgraphsListProps = {
  data: ApolloTypes.SubgraphsListQueryMock;
  statsSortKey: NormalizedSubgraphsMetricsField;
  selectedSubgraphName: string;
  loading: boolean;
};

export const SubgraphsListBody = ({
  data,
  statsSortKey,
  selectedSubgraphName,
  loading,
}: SubgraphsListProps) => {
  const subgraphs =
    data.graph?.variant?.subgraphInsightsListMock?.subgraphs ?? [];

  const subgraphsListItems = subgraphs.map((stats) => {
    return {
      ...stats,
      ...fromGQLSubgraphsListItemToSubgraphsListItem(stats),
      statsSortKey,
      subgraphId: stats.subgraphName,
      isSelected: stats.subgraphName === selectedSubgraphName,
    };
  });

  const subgraphsListContent = subgraphsListItems.map((item) => (
    <SubgraphsListItem key={item.subgraphId} {...item} loading={loading} />
  ));

  return (
    <div
      className={classnames('p-0 py-2', {
        'motion-safe:animate-pulse-faded': loading,
      })}
    >
      <List isInteractive>{subgraphsListContent}</List>
    </div>
  );
};
